import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=logged out, obj=logged in
  const [token, setToken] = useState(() => localStorage.getItem("ic_admin_token") || "");

  const authAxios = useCallback(
    () => axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} }),
    [token]
  );

  useEffect(() => {
    if (!token) { setAdmin(false); return; }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setAdmin(res.data))
      .catch(() => { setAdmin(false); localStorage.removeItem("ic_admin_token"); setToken(""); });
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("ic_admin_token", res.data.access_token);
    setToken(res.data.access_token);
    setAdmin(res.data.admin);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("ic_admin_token");
    setToken("");
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, token, login, logout, authAxios }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
